module.exports = __webpack_public_path__ + "img/Opening.2f0bfd63.svg";